import { FC } from "react";
import styled from "styled-components";
import NoArticlesFound from "./NoArticlesFound";
import { FixaListViewWithBackground } from "../../RefillAreas/RefillAreasList";
import { MediumSkeletonListItem } from "@coworker/app/src/components/RoomSettings/Molecules/skeletons/MediumSkeletonListItem";
import type { MultiOrderItems } from "../../../types/items";
import { LoadMore } from "../../../../shared/components/LoadMore/LoadMore";
import { ItemsListViewItemWithGroup } from "@coworker/apprestructured/src/multi-order-addons/components/ItemsSelection/ItemsListView/ItemsListViewItem/ItemsListViewItemWithGroup";

const Divider = styled.div`
  height: 8px;
  width: 100%;
  background: var(--grey100);
`;

const ItemsListView: FC<{
  items: MultiOrderItems | undefined;
  isLoading: boolean;
  isLoadingMore: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
  groupBy: string;
  clearFilters: () => void;
}> = ({
  items,
  isLoading,
  isLoadingMore,
  hasNextPage,
  fetchNextPage,
  groupBy,
  clearFilters,
}) => {
  if (!isLoading && items && !items.length)
    return <NoArticlesFound clearFilters={clearFilters} />;

  if ((isLoading && !isLoadingMore) || !items)
    return <MediumSkeletonListItem />;

  return (
    <FixaListViewWithBackground id="articles-list">
      {!groupBy && <Divider />}
      {items.map((item, index) => (
        <ItemsListViewItemWithGroup
          key={index}
          item={item}
          index={index}
          groupBy={groupBy}
          previousItem={items[index - 1] ?? null}
        />
      ))}
      {isLoadingMore && (
        <>
          <MediumSkeletonListItem />
          <MediumSkeletonListItem />
        </>
      )}
      {hasNextPage && (
        <LoadMore
          onLoadMoreClick={fetchNextPage}
          loadedItemsCount={items.length || 0}
          isFetching={isLoading}
        />
      )}
    </FixaListViewWithBackground>
  );
};

export default ItemsListView;
